import React from 'react';
import { TESTIMONIALS } from '../mock';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  return (
    <section className="py-24 lg:py-28 bg-[#08080a]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="mb-14 max-w-3xl">
          <p className="section-label mb-4">Loved by clients</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.05]">
            Let our clients do the talking for us.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="bg-[#111114] border border-white/10 rounded-2xl p-8 hover:border-[#F5CD1B]/30 transition-colors">
              <Quote className="text-[#F5CD1B]" size={26} />
              <p className="text-white/85 text-lg leading-relaxed mt-5">“{t.quote}”</p>
              <div className="flex items-center gap-3 mt-8">
                <div className="w-11 h-11 rounded-full bg-[#F5CD1B] text-[#0b0b0d] flex items-center justify-center font-bold">
                  {t.initial}
                </div>
                <div>
                  <p className="text-white font-semibold">{t.name}</p>
                  <p className="text-white/50 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
